export function LoadingHome() {
    return (
        <div className='flex flex-col items-center justify-center h-[calc(100vh-200px)] text-center p-8'>
            <div className='relative w-20 h-20 mb-6'>
                <div className='absolute inset-0 border-4 border-blue-200 rounded-full'></div>
                <div className='absolute inset-0 border-4 border-transparent border-t-[#5863F9] rounded-full animate-spin'></div>
                <div className='absolute inset-2 border-4 border-transparent border-t-[#5863F9] rounded-full animate-spin' style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
            </div>
            <p className='text-gray-600 text-lg'>App vinculando com o campo personalizado</p>
            <p className='text-gray-800 font-semibold text-xl mt-1'><strong>Contas do Ticket</strong></p>
            <p className='text-gray-500 text-sm mt-4 animate-pulse'>Aguarde...</p>
        </div>
    )
}